const FEATURE_FLAGS = {
    WEB_SESSION_REPLAY_HEATMAP: 'web-session-replay-heatmap',
    DRUGBOOK_BATCH_OPTIONAL: 'drugbook-batch-optional',
    WEB_PATIENT_DOCUMENTS: 'web-patient-documents',
    FRESH_HEALTH_FORM_URL: 'fresh-health-form-url',
    // FRH-734: must match web-api's server/constants/featureFlags.js key
    // exactly ('payto-payment-method') - same LaunchDarkly flag, evaluated
    // independently on each side.
    PAYTO_PAYMENT_METHOD: 'payto-payment-method',
  };
  
  export default FEATURE_FLAGS;